import { Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CUSTOM_TEMPLATES, OSCAR_WINNER } from "../../../../Data/FormWidgets";
import { CustomTemplate } from "../../../../Constant";

const CustomTemplates = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={CustomTemplate} span={CUSTOM_TEMPLATES} />
        <CardBody>
          <div id="custom-templates">
            <Form className="theme-form">
              <div>
                <Typeahead options={OSCAR_WINNER} placeholder="Oscar winners" id="Custom Templates"/>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomTemplates;
